// extracted by mini-css-extract-plugin
module.exports = {"container":"Thumbnail_container__2rXZR","image":"Thumbnail_image__muqeV","square":"Thumbnail_square___A5Al","circle":"Thumbnail_circle___nuFB"};